/* istanbul ignore file */

/**
 * Window object wrapper
 */
export const WindowObj = window;
